<template>
  <layout-card-wrap hasHeaderSlot
                    v-loading="loading">
    <template slot="title">选择商品</template>
    <template slot="form">
      <el-input placeholder="请输入商品备注"
                v-model="config.productNameRemark"
                style="width: 160px">
      </el-input>
      <el-input placeholder="请输入商品名称"
                v-model="config.productName"
                style="width: 200px;margin-left: 10px">
        <el-button slot="append"
                   icon="el-icon-search"
                   @click="handleCurrentChange(1)"></el-button>
      </el-input>
    </template>
    <el-table border
              v-loading="loading"
              :data="list"
              highlight-current-row
              @current-change="handleCurrentRowChange">
      <el-table-column label=""
                       width="50">
        <template slot-scope="{row}">
          <el-radio v-model="currentId"
                    :label="row.productId">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column label="商品名称"
                       min-width="160">
        <template slot-scope="{row}">
          {{row.productName}}
        </template>
      </el-table-column>
      <el-table-column label="商品备注"
                       min-width="80">
        <template slot-scope="{row}">
          <span v-if="row.productNameRemark">({{row.productNameRemark}})</span>
        </template>
      </el-table-column>
      <el-table-column label="商品类型"
                       prop="categoryName">
      </el-table-column>
      <el-table-column label="贸易类别">
        <template slot-scope="{row}">
          {{ row.tradeType | tradeType()}}
        </template>
      </el-table-column>
      <el-table-column label="标签类型">
        <template slot-scope="{row}">
          {{ row.tagType | tagType()}}
        </template>
      </el-table-column>
      <el-table-column label="赋码方式">
        <template slot-scope="{row}">
          {{ row.codingType | codingType()}}
        </template>
      </el-table-column>
      <el-table-column label="备案时间">
        <template slot-scope="{row}">
          {{ row.createdTime | dateformat('YYYY-MM-DD')}}
        </template>
      </el-table-column>
    </el-table>
    <template slot="footer">
      <el-pagination background
                     @current-change="handleCurrentChange"
                     :current-page.sync="config.pageNum"
                     :page-size="config.pageSize"
                     layout="total, prev, pager, next"
                     :total="total">
      </el-pagination>
    </template>
  </layout-card-wrap>
</template>

<script>
export default {
  name: 'product-select-table',
  data () {
    return {
      loading: false,
      current: null,
      currentId: null,
      config: {
        pageNum: 1,
        pageSize: 10,
        productName: '',
        productNameRemark: '',
        status: 2
      },
      list: [],
      total: 0
    }
  },
  computed: {
    tagTypes () {
      return this.$route.query.tagModel === '1' ? [1, 2, 3, 4] : [2, 3, 4]
    }
  },
  methods: {
    handleCurrentRowChange (row) {
      this.current = row || {}
      this.currentId = row.productId
    },
    handleCurrentChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList () {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          vendorId: this.$route.query.vendorId,
          tagTypes: this.tagTypes
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    getCurrent () {
      return this.current
    }
  },
  mounted () {
    this.fetchList()
  }
}
</script>
